module.exports = __webpack_public_path__ + "static/media/sydney-1.628b397e.jpg";